"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _Constants = require("../../Constants");

var _Constants2 = require("FileManagerCore/Constants");

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _loadDropbox = _interopRequireDefault(require("../../utils/loadDropbox"));

var DropBoxButton = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(DropBoxButton, _Component);

  function DropBoxButton(props) {
    var _this;

    (0, _classCallCheck2.default)(this, DropBoxButton);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DropBoxButton).call(this, props));
    _this.mounted = false;
    _this.handleDropboxDidLoad = _this.handleDropboxDidLoad.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleDropboxFailedLoad = _this.handleDropboxFailedLoad.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSuccess = _this.handleSuccess.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(DropBoxButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      (0, _loadDropbox.default)().then(this.handleDropboxDidLoad, this.handleDropboxFailedLoad).done();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "handleDropboxDidLoad",
    value: function handleDropboxDidLoad() {
      if (this.mounted) {
        this.setState({
          status: _Constants2.RequestStatus.SUCCEEDED
        });
      }
    }
  }, {
    key: "handleDropboxFailedLoad",
    value: function handleDropboxFailedLoad() {
      if (this.mounted) {
        this.setState({
          status: _Constants2.RequestStatus.FAILED
        });
      }
    }
  }, {
    key: "getFileTypeForDrawer",
    value: function getFileTypeForDrawer() {
      var type = this.props.type;

      switch (type) {
        case _Constants.DrawerTypes.IMAGE:
          return _Constants2.TypeToExtensions.get(_Constants2.FileTypes.IMG).map(function (item) {
            return "." + item;
          }).toArray();

        case _Constants.DrawerTypes.DOCUMENT:
          return _Constants2.TypeToExtensions.get(_Constants2.FileTypes.DOCUMENT).map(function (item) {
            return "." + item;
          }).toArray();

        default:
          return [];
      }
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(files) {
      var _this2 = this;

      files.forEach(function (file) {
        _this2.props.importFile(file);
      });
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      window.Dropbox.choose({
        success: this.handleSuccess,
        multiselect: this.props.useMultiSelect,
        extensions: this.getFileTypeForDrawer(),
        linkType: 'direct'
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_UIButton.default, {
        use: "link",
        onClick: this.handleClick,
        disabled: window.Dropbox === undefined
      }, _react.default.createElement(_UIIcon.default, {
        className: "m-right-2",
        name: "dropbox"
      }), _react.default.createElement(_FormattedMessage.default, {
        message: "FileManagerLib.actions.addFromDropbox"
      }));
    }
  }]);
  return DropBoxButton;
}(_react.Component);

exports.default = DropBoxButton;
DropBoxButton.propTypes = {
  useMultiSelect: _propTypes.default.bool.isRequired,
  importFile: _propTypes.default.func.isRequired,
  type: _propTypes.default.oneOf(Object.keys(_Constants.DrawerTypes)).isRequired
};
module.exports = exports.default;